import { combineReducers } from 'redux'
import { Action } from 'actions/index'
import { AuthAppState } from 'interfaces/auth'
import { FORM_SUBMITTED_SUCCESSFULLY } from 'actions/formActions'
import { FORMS_WITH_PASSWORD } from 'constants/forms'
import { isFailAction, isSuccessAction } from 'helpers/actionsHelpers'
import {
  GET_PASSWORD_STRENGTH,
  RESET_PASSWORD_STRENGTH,
  SET_DEVICE_UNVERIFIED,
  SET_DEVICE_VERIFIED,
  TOGGLE_PASSWORD_RESET_CODE_SENT,
} from 'actions/authActions'
import { PAGE_CHANGED } from 'actions/globalActions'
import { PASSWORD_RESET_URL } from 'tangle-shared'

const deviceVerificationReducer = (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_DEVICE_UNVERIFIED:
      return true
    case SET_DEVICE_VERIFIED:
      return false
    default:
      return state
  }
}

const resetCodeSentReducer = (state = false, action: Action): boolean => {
  switch (action.type) {
    case PAGE_CHANGED:
      if (action.payload.next !== PASSWORD_RESET_URL) {
        return false
      } else {
        return state
      }
    case TOGGLE_PASSWORD_RESET_CODE_SENT:
      return action.payload
    default:
      return state
  }
}

const passwordStrengthReducer = (state = null, action: Action) => {
  switch (action.type) {
    case GET_PASSWORD_STRENGTH: {
      if (isSuccessAction(action)) {
        return action.payload.response.strength
      }

      if (isFailAction(action)) {
        return null
      }

      return state
    }

    case RESET_PASSWORD_STRENGTH: {
      return null
    }

    case FORM_SUBMITTED_SUCCESSFULLY:
      if (FORMS_WITH_PASSWORD.includes(action.payload.formName)) {
        return null
      }

    default:
      return state
  }
}

export default combineReducers<AuthAppState>({
  resetCodeSent: resetCodeSentReducer,
  deviceUnverified: deviceVerificationReducer,
  passwordStrength: passwordStrengthReducer,
})
